import axios from "axios";

export const getModalitaPagamentoApi = (params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/quota/modalita/`, {
        params: params
    });
}

export const getModalitaPagamentoByIdApi = (idModalita, params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/quota/modalita/${idModalita}`, {
        params: params
    });
}

export const deleteModalitaPagamentoApi = (idModalita, params = {}) => {
    return axios.delete(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/quota/modalita/${idModalita}`, {
        params: params
    });
}

export const getQuoteApi = (params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/quota/`, {
        params: params
    });
}

export const deleteQuotaApi = (idQuota, params = {}) => {
    return axios.delete(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/quota/${idQuota}`, {
        params: params
    });
}

export const getQuotaVeicoloByIdApi = (idQuotaVeicolo, params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/quota/veicolo/${idQuotaVeicolo}`, {
        params: params
    });
}

export const getTipiVersamentoApi = (params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/quota/tipi-versamento/`, {
        params: params
    });
}

export const getDocumentoQuotaByIdApi = (idQuota, idDocumento, params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/quota/${idQuota}/documento/${idDocumento}`, {
        params: params
    });
}

export const deleteDocumentoQuotaApi = (idQuota, idDocumento, params = {}) => {
    return axios.delete(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/quota/${idQuota}/documento/${idDocumento}`, {
        params: params
    });
}

export const getTransazioniApi = (params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/quota/transazione/`, {
        params: params
    });
}

export const getModuloQuotaByTipoApi = (tipoModulo, params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/quota/modulo/${tipoModulo}`, {
        params: params
    });
}